// TODO: retirer ce helper quand la config TZ de l'API/DB sera alignée.
// Contexte : Symfony écrit les DATETIME en heure locale Europe/Paris, mais
// le driver mysql2 de l'API Nest (conteneur en UTC, pas d'option `timezone`)
// les réinterprète en UTC. L'ISO renvoyé par l'API contient donc déjà
// l'heure Paris voulue, simplement étiquetée à tort comme UTC. Lire les
// composants UTC restitue l'heure d'origine sans double conversion.
export function formatDateTimeAsUtc(date: string | Date | null | undefined): string {
  if (!date) return '—';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '—';
  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const year = d.getUTCFullYear();
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
